<template>
  <vs-tabs>
    <vs-tab label="Warehouse">
      <Warehouse/>
    </vs-tab>
  </vs-tabs>
</template>
<script>
import Warehouse from "./warehouse.vue";

export default {
  components: {
    Warehouse,
  },
  data() {
    return {
    };
  },
};
</script>